import { useAuth } from "./useAuth";

type Role = "admin" | "user" | "moderator";

export function useRole() {
  const { user } = useAuth();

  const hasRole = (role: Role): boolean => {
    return user?.role === role;
  };

  // Check both isAdmin flag and role field for backwards compatibility
  const isAdmin = user?.isAdmin === true || user?.role === "admin";
  const isModerator = user?.role === "moderator";
  const isUser = user?.role === "user" || !user?.role; // Default to user if role not set

  return {
    role: user?.role || "user",
    hasRole,
    isAdmin,
    isModerator,
    isUser,
  };
}
